import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
  Avatar,
  Chip,
  Button,
  TextField,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Paper,
  Alert,
  CircularProgress,
  InputAdornment,
  Grid,
  Tab,
  Tabs,
  Card,
  CardContent,
  Divider,
  List,
  Tooltip,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ScheduleIcon from '@mui/icons-material/Schedule';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SendIcon from '@mui/icons-material/Send';
import InfoIcon from '@mui/icons-material/Info';
import AddCommentIcon from '@mui/icons-material/AddComment';
import CommentIcon from '@mui/icons-material/Comment';
import RefreshIcon from '@mui/icons-material/Refresh';
import dayjs from 'dayjs';
import moment from 'moment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDateTimePicker } from '@mui/x-date-pickers/DesktopDateTimePicker';
import { useDispatch, useSelector } from 'react-redux';
import { Notify } from '../Utility/Notify';
import { AddStageCommentAction } from '../Redux/Actions/RoleData_Actions';
import { GetAll_stage_Data } from '../Redux/Actions/Stage_Action';
import { Get_AllComments_AddedBy_User_Action } from '../Redux/Actions/MeetingCommentsAction';

// Styled Components
const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    borderRadius: 16,
    minWidth: '500px',
    maxWidth: '800px',
    width: '100%',
    height: '80vh',
    display: 'flex',
    flexDirection: 'column',
  },
}));

const GradientButton = styled(Button)(({ theme }) => ({
  background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
  border: 0,
  borderRadius: 25,
  boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)',
  color: 'white',
  height: 48,
  padding: '0 30px',
  '&:hover': {
    background: 'linear-gradient(45deg, #1976D2 30%, #1CB5E0 90%)',
  },
}));

// Tab Panel Component
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`sheet-tabpanel-${index}`}
      aria-labelledby={`sheet-tab-${index}`}
      style={{ height: '100%', overflow: 'auto' }}
      {...other}
    >
      {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
    </div>
  );
}

export const ShowUserSheet = ({ open, onClose, lead, userlogin }) => {
  const dispatch = useDispatch();

  // Tab state
  const [tabValue, setTabValue] = useState(0);

  // States for Add Comment Tab
  const [selectedStageForSheet, setSelectedStageForSheet] = useState(null);
  const [showMeetingDateTime, setShowMeetingDateTime] = useState(false);
  const [meetingDateTime, setMeetingDateTime] = useState(dayjs());
  const [salesDeveloperNameSheet, setSalesDeveloperNameSheet] = useState('');
  const [commentTextSheet, setCommentTextSheet] = useState('');
  const [isSubmittingSheet, setIsSubmittingSheet] = useState(false);

  // States for Comments Tab
  const [comments, setComments] = useState([]);
  const [isCommentsLoading, setIsCommentsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCommentsCount, setTotalCommentsCount] = useState(0);
  const [hasNext, setHasNext] = useState(false);
  const [hasPrev, setHasPrev] = useState(false);

  console.log(lead, 'lead');
  console.log(userlogin, 'userlogin');

  // Get stages from Redux
  const stagesFromRedux = useSelector((state) => state.Allstages?.stage?.data || []);

  // Get comments from Redux
  const resgetallcoments = useSelector((state) => state.AllMeetingComments?.MeetingComments);

  // Filter stages to show only Meeting, EOI, and Done Deal
  const allstagesshow = stagesFromRedux.filter((stage) =>
    ['Meeting', 'EOI', 'Done Deal'].includes(stage.name),
  );

  // Load stages when dialog opens
  useEffect(() => {
    if (open && stagesFromRedux.length === 0) {
      dispatch(GetAll_stage_Data());
    }
  }, [open, dispatch, stagesFromRedux.length]);

  // متابعة التغييرات في الـ Redux state
  useEffect(() => {
    if (resgetallcoments && tabValue === 1) {
      console.log('📊 Comments from Redux:', resgetallcoments);

      // استخراج البيانات من الـ response
      if (resgetallcoments?.data) {
        const commentsData = resgetallcoments.data;
        const pagination = resgetallcoments.data.pagination || {};

        setComments(commentsData);
        setCurrentPage(pagination.page || 1);
        setTotalPages(pagination.totalPages || 1);
        setHasNext(pagination.hasNextPage || false);
        setHasPrev(pagination.hasPrevPage || false);
        setTotalCommentsCount(pagination.totalResults || commentsData.length);

        console.log('✅ Comments loaded:', {
          count: commentsData.length,
          total: pagination.totalResults,
          page: pagination.page,
        });
      } else if (Array.isArray(resgetallcoments)) {
        // لو الـ response هو array مباشرة
        setComments(resgetallcoments);
        setTotalCommentsCount(resgetallcoments.length);
      }

      setIsCommentsLoading(false);
    }
  }, [resgetallcoments, tabValue]);

  // Load comments when switching to Comments tab
  useEffect(() => {
    if (open && tabValue === 1 && lead?._id && userlogin?.data?._id) {
      loadComments(1);
    }
  }, [open, tabValue, lead?._id, userlogin?.data?._id]);

  // Load comments when dialog opens and lead/user are available
  useEffect(() => {
    if (open && lead?._id && userlogin?.data?._id) {
      // لو التاب الحالي هو comments، حمل على طول
      if (tabValue === 1) {
        loadComments(1);
      }
    }
  }, [open, lead?._id, userlogin?.data?._id]);

  // Log for debugging
  console.log('🎯 Stages loaded:', allstagesshow);

  // Load comments function
  const loadComments = async (page = 1) => {
    if (!lead?._id || !userlogin?.data?._id) {
      console.error('❌ Missing leadId or userId');
      Notify('error', 'Missing lead or user information', 'error');
      return;
    }

    setIsCommentsLoading(true);

    try {
      console.log('📥 Loading comments for:', {
        leadId: lead._id,
        userId: userlogin.data._id,
        page: page,
      });

      // استدعاء الأكشن الجديد
      await dispatch(Get_AllComments_AddedBy_User_Action(lead._id, userlogin.data._id));
    } catch (error) {
      console.error('❌ Error loading comments:', error);
      Notify('error', error?.response?.data?.message || 'Failed to load comments', 'error');
      setComments([]);
      setTotalCommentsCount(0);
      setIsCommentsLoading(false);
    }
  };

  // Handle tab change
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);

    // لو غيرت للتاب بتاع comments و comments فاضية، حمل البيانات
    if (newValue === 1 && comments.length === 0 && lead?._id && userlogin?.data?._id) {
      loadComments(1);
    }
  };

  // Handle Submit
  const handleSubmitStageComment = async () => {
    // Validation
    if (!selectedStageForSheet) {
      return Notify('error', 'Please select a stage', 'error');
    }
    if (!salesDeveloperNameSheet.trim()) {
      return Notify('error', 'Please enter developer name', 'error');
    }
    if (!commentTextSheet.trim()) {
      return Notify('error', 'Please enter your comment', 'error');
    }
    if (selectedStageForSheet.name === 'Meeting' && !meetingDateTime) {
      return Notify('error', 'Please select meeting date & time', 'error');
    }

    setIsSubmittingSheet(true);

    try {
      const commentData = {
        comment: commentTextSheet,
        salesdeveloperName: salesDeveloperNameSheet,
        stageDate:
          selectedStageForSheet.name === 'Meeting'
            ? meetingDateTime.toISOString()
            : dayjs().toISOString(),
        commentBy: userlogin?.data?._id,
      };

      console.log('📝 Submitting stage comment:', {
        leadId: lead?._id,
        stageId: selectedStageForSheet._id,
        stageName: selectedStageForSheet.name,
        commentData,
      });

      const response = await dispatch(
        AddStageCommentAction(lead?._id, selectedStageForSheet._id, commentData),
      );

      if (response?.status === 201 || response?.data?.status === 'success') {
        Notify('success', 'Comment added successfully!', 'success');

        // Reset form
        setSelectedStageForSheet(null);
        setShowMeetingDateTime(false);
        setMeetingDateTime(dayjs());
        setSalesDeveloperNameSheet('');
        setCommentTextSheet('');

        // Switch to comments tab and reload comments
        setTabValue(1);
        loadComments(1);
      }
    } catch (error) {
      console.error('❌ Error submitting comment:', error);
      const errorMessage = error.response?.data?.message || 'Failed to add comment';
      Notify('error', errorMessage, 'error');
    } finally {
      setIsSubmittingSheet(false);
    }
  };

  // Get stage color
  const getStageColor = (stageName) => {
    const colors = {
      Meeting: '#ff9800',
      EOI: '#2196f3',
      'Done Deal': '#4caf50',
      'Follow Up': '#9c27b0',
      'No Answer': '#f44336',
      Answer: '#4caf50',
      Pending: '#ff9800',
      Fresh: '#00bcd4',
      Transfer: '#ff5722',
    };
    return colors[stageName] || '#757575';
  };

  return (
    <StyledDialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      {/* Header */}
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid',
          borderColor: 'divider',
          pb: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Avatar sx={{ bgcolor: 'secondary.main' }}>
            <AssignmentIcon />
          </Avatar>
          <Box>
            <Typography variant="h6" fontWeight={600}>
              Lead Sheet
            </Typography>
            {lead && (
              <Typography variant="body2" color="textSecondary">
                {lead.name} • {lead.phone} • {lead.project?.name || 'No Project'}
              </Typography>
            )}
          </Box>
        </Box>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* Tabs */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="sheet tabs">
          <Tab
            icon={<AddCommentIcon />}
            iconPosition="start"
            label="Add Comment"
            id="sheet-tab-0"
            aria-controls="sheet-tabpanel-0"
          />
          <Tab
            icon={<CommentIcon />}
            iconPosition="start"
            label={`All Comments ${totalCommentsCount > 0 ? `(${totalCommentsCount})` : ''}`}
            id="sheet-tab-1"
            aria-controls="sheet-tabpanel-1"
          />
        </Tabs>
      </Box>

      {/* Tab 1: Add Comment */}
      <TabPanel value={tabValue} index={0}>
        {/* Show loading state if stages not loaded */}
        {allstagesshow.length === 0 ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 4 }}>
            <CircularProgress size={24} sx={{ mr: 2 }} />
            <Typography>Loading stages...</Typography>
          </Box>
        ) : (
          <>
            {/* Radio Buttons for Stage Selection */}
            <Box sx={{ mb: 3 }}>
              <Typography variant="subtitle1" fontWeight={600} gutterBottom color="text.primary">
                Select Stage
              </Typography>

              <FormControl component="fieldset" sx={{ width: '100%' }}>
                <RadioGroup
                  value={selectedStageForSheet?._id || ''}
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    const selectedStage = allstagesshow.find((stage) => stage._id === selectedId);

                    if (selectedStage) {
                      console.log('Selected Stage:', selectedStage.name, 'ID:', selectedStage._id);

                      if (selectedStage.name === 'Meeting') {
                        setShowMeetingDateTime(true);
                      } else {
                        setShowMeetingDateTime(false);
                      }

                      setSelectedStageForSheet(selectedStage);
                      setMeetingDateTime(dayjs());
                    }
                  }}
                >
                  {/* Meeting option */}
                  {allstagesshow
                    .filter((stage) => stage.name === 'Meeting')
                    .map((stage) => (
                      <FormControlLabel
                        key={stage._id}
                        value={stage._id}
                        control={<Radio />}
                        label={
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <ScheduleIcon color="warning" />
                            <Typography fontWeight={500}>{stage.name}</Typography>
                          </Box>
                        }
                        sx={{
                          mb: 1,
                          p: 1,
                          borderRadius: 1,
                          border: '1px solid',
                          borderColor:
                            selectedStageForSheet?._id === stage._id ? 'warning.main' : 'divider',
                          bgcolor:
                            selectedStageForSheet?._id === stage._id
                              ? 'warning.lighter'
                              : 'transparent',
                          width: '100%',
                          mx: 0,
                        }}
                      />
                    ))}

                  {/* EOI option */}
                  {allstagesshow
                    .filter((stage) => stage.name === 'EOI')
                    .map((stage) => (
                      <FormControlLabel
                        key={stage._id}
                        value={stage._id}
                        control={<Radio />}
                        label={
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <MonetizationOnIcon color="info" />
                            <Typography fontWeight={500}>{stage.name}</Typography>
                          </Box>
                        }
                        sx={{
                          mb: 1,
                          p: 1,
                          borderRadius: 1,
                          border: '1px solid',
                          borderColor:
                            selectedStageForSheet?._id === stage._id ? 'info.main' : 'divider',
                          bgcolor:
                            selectedStageForSheet?._id === stage._id
                              ? 'info.lighter'
                              : 'transparent',
                          width: '100%',
                          mx: 0,
                        }}
                      />
                    ))}

                  {/* Done Deal option */}
                  {allstagesshow
                    .filter((stage) => stage.name === 'Done Deal')
                    .map((stage) => (
                      <FormControlLabel
                        key={stage._id}
                        value={stage._id}
                        control={<Radio />}
                        label={
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <CheckCircleIcon color="success" />
                            <Typography fontWeight={500}>{stage.name}</Typography>
                          </Box>
                        }
                        sx={{
                          mb: 1,
                          p: 1,
                          borderRadius: 1,
                          border: '1px solid',
                          borderColor:
                            selectedStageForSheet?._id === stage._id ? 'success.main' : 'divider',
                          bgcolor:
                            selectedStageForSheet?._id === stage._id
                              ? 'success.lighter'
                              : 'transparent',
                          width: '100%',
                          mx: 0,
                        }}
                      />
                    ))}
                </RadioGroup>
              </FormControl>
            </Box>

            {/* Meeting DateTimePicker */}
            {selectedStageForSheet?.name === 'Meeting' && (
              <Box sx={{ mb: 3 }}>
                <Typography variant="subtitle1" fontWeight={600} gutterBottom color="text.primary">
                  Schedule Meeting Date & Time
                </Typography>
                <Paper
                  elevation={0}
                  sx={{
                    p: 2.5,
                    border: '2px solid',
                    borderColor: 'warning.light',
                    borderRadius: 2,
                    bgcolor: 'warning.lighter',
                  }}
                >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDateTimePicker
                      label="Select Meeting Date & Time"
                      value={meetingDateTime}
                      onChange={(newValue) => setMeetingDateTime(newValue)}
                      ampm={true}
                      slotProps={{
                        popper: {
                          sx: { zIndex: 50001 },
                        },
                      }}
                      renderInput={(params) => <TextField {...params} fullWidth />}
                    />
                  </LocalizationProvider>
                </Paper>
              </Box>
            )}

            {/* Sales Developer Name */}
            <Box sx={{ mb: 3 }}>
              <Typography variant="subtitle1" fontWeight={600} gutterBottom color="text.primary">
                Sales Developer Name
              </Typography>
              <TextField
                fullWidth
                label="Developer Name"
                value={salesDeveloperNameSheet}
                onChange={(e) => setSalesDeveloperNameSheet(e.target.value)}
                placeholder="Enter your name"
                variant="outlined"
                required
                inputProps={{
                  style: { fontSize: '16px' },
                }}
              />
            </Box>

            {/* Comment Text Area */}
            <Box sx={{ mb: 3 }}>
              <Typography variant="subtitle1" fontWeight={600} gutterBottom color="text.primary">
                Your Comment
              </Typography>
              <TextField
                fullWidth
                multiline
                rows={4}
                label="Write your comment..."
                value={commentTextSheet}
                onChange={(e) => setCommentTextSheet(e.target.value)}
                placeholder="Describe the meeting, EOI details, or deal completion..."
                required
                variant="outlined"
              />
            </Box>

            {/* Validation Summary */}
            {(!selectedStageForSheet ||
              !salesDeveloperNameSheet.trim() ||
              !commentTextSheet.trim()) && (
              <Alert severity="error" sx={{ mt: 2, mb: 2 }}>
                ⚠️ Please fill in all required fields
              </Alert>
            )}

            {selectedStageForSheet?.name === 'Meeting' && !meetingDateTime && (
              <Alert severity="warning" sx={{ mt: 2, mb: 2 }}>
                ⚠️ Please select meeting date and time
              </Alert>
            )}

            {/* Submit Button */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3, mb: 2 }}>
              <GradientButton
                type="submit"
                disabled={isSubmittingSheet}
                startIcon={isSubmittingSheet ? null : <SendIcon />}
                endIcon={isSubmittingSheet ? <CircularProgress size={20} color="inherit" /> : null}
                size="large"
                sx={{
                  minWidth: 250,
                  bgcolor:
                    selectedStageForSheet?.name === 'Done Deal'
                      ? 'success.main'
                      : selectedStageForSheet?.name === 'EOI'
                        ? 'info.main'
                        : selectedStageForSheet?.name === 'Meeting'
                          ? 'warning.main'
                          : 'primary.main',
                }}
                onClick={handleSubmitStageComment}
              >
                {isSubmittingSheet
                  ? 'Adding...'
                  : selectedStageForSheet?.name === 'Done Deal'
                    ? '🎉 Add Done Deal Comment'
                    : selectedStageForSheet?.name === 'EOI'
                      ? '💰 Add EOI Comment'
                      : selectedStageForSheet?.name === 'Meeting'
                        ? '📅 Add Meeting Comment'
                        : 'Add Stage Comment'}
              </GradientButton>
            </Box>
          </>
        )}
      </TabPanel>

      {/* Tab 2: All Comments */}
      <TabPanel value={tabValue} index={1}>
        <Box sx={{ height: '100%' }}>
          {/* Header with refresh button */}
          <Box
            sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}
          >
            <Typography variant="h6" fontWeight={600}>
              All Comments
              {totalCommentsCount > 0 && (
                <Chip
                  label={`${totalCommentsCount} total`}
                  size="small"
                  sx={{ ml: 1, bgcolor: 'primary.main', color: 'white' }}
                />
              )}
            </Typography>
            <Tooltip title="Refresh">
              <IconButton size="small" onClick={() => loadComments(1)} disabled={isCommentsLoading}>
                <RefreshIcon />
              </IconButton>
            </Tooltip>
          </Box>

          {/* Comments List */}
          {isCommentsLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 4 }}>
              <CircularProgress size={24} sx={{ mr: 2 }} />
              <Typography>Loading comments...</Typography>
            </Box>
          ) : comments.length > 0 ? (
            <>
              <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                {comments.map((comment, index) => (
                  <React.Fragment key={comment._id || index}>
                    <Card variant="outlined" sx={{ mb: 2, borderRadius: 2 }}>
                      <CardContent>
                        {/* Comment Header - use commentBy */}
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                            mb: 2,
                          }}
                        >
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Avatar
                              sx={{
                                width: 32,
                                height: 32,
                                bgcolor: comment.commentBy?.name
                                  ? getStageColor(comment.stage?.name)
                                  : 'grey.500',
                                fontSize: '0.8rem',
                              }}
                            >
                              {comment.commentBy?.name?.charAt(0) || '?'}
                            </Avatar>
                            <Box>
                              <Typography variant="subtitle2" fontWeight={600}>
                                {comment.commentBy?.name || 'Unknown User'}
                              </Typography>
                              <Typography variant="caption" color="text.secondary">
                                {comment.commentBy?.role || 'User'}
                              </Typography>
                            </Box>
                          </Box>
                          <Chip
                            label={comment.stage?.name || 'No Stage'}
                            size="small"
                            sx={{
                              bgcolor: getStageColor(comment.stage?.name),
                              color: 'white',
                              fontWeight: 500,
                            }}
                          />
                        </Box>

                        {/* Stage Date */}
                        {comment.stageDate && (
                          <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ display: 'block', mb: 1 }}
                          >
                            Stage Date: {moment(comment.stageDate).format('DD/MM/YYYY hh:mm A')}
                          </Typography>
                        )}

                        {/* Comment Text */}
                        <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap', mb: 2 }}>
                          {comment.comment}
                        </Typography>

                        {/* Developer Name */}
                        {comment.salesdeveloperName && (
                          <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ display: 'block' }}
                          >
                            Sales Developer: {comment.salesdeveloperName}
                          </Typography>
                        )}

                        {/* Comment Date */}
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          sx={{ display: 'block', mt: 1 }}
                        >
                          Added: {moment(comment.createdAt).format('DD/MM/YYYY hh:mm A')}
                        </Typography>

                        {/* Replies */}
                        {comment.replies && comment.replies.length > 0 && (
                          <Box
                            sx={{ mt: 2, pl: 2, borderLeft: '2px solid', borderColor: 'divider' }}
                          >
                            <Typography variant="caption" fontWeight={600}>
                              Replies:
                            </Typography>
                            {comment.replies.map((reply, idx) => (
                              <Box key={idx} sx={{ mt: 1 }}>
                                <Typography variant="body2">
                                  <strong>{reply.user?.name}:</strong> {reply.text}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  {moment(reply.date).format('DD/MM/YYYY hh:mm A')}
                                </Typography>
                              </Box>
                            ))}
                          </Box>
                        )}
                      </CardContent>
                    </Card>
                    {index < comments.length - 1 && <Divider sx={{ my: 1 }} />}
                  </React.Fragment>
                ))}
              </List>

              {/* Pagination */}
              {totalPages > 1 && (
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 2,
                    mt: 2,
                  }}
                >
                  <Button
                    variant="outlined"
                    size="small"
                    disabled={!hasPrev || isCommentsLoading}
                    onClick={() => {
                      setCurrentPage((prev) => prev - 1);
                      loadComments(currentPage - 1);
                    }}
                  >
                    Previous
                  </Button>
                  <Typography variant="body2">
                    Page {currentPage} of {totalPages}
                  </Typography>
                  <Button
                    variant="outlined"
                    size="small"
                    disabled={!hasNext || isCommentsLoading}
                    onClick={() => {
                      setCurrentPage((prev) => prev + 1);
                      loadComments(currentPage + 1);
                    }}
                  >
                    Next
                  </Button>
                </Box>
              )}
            </>
          ) : (
            <Box sx={{ textAlign: 'center', py: 4 }}>
              <CommentIcon sx={{ fontSize: 48, color: 'text.disabled', mb: 2 }} />
              <Typography variant="h6" color="text.secondary" gutterBottom>
                No Comments Yet
              </Typography>
              <Typography variant="body2" color="text.secondary" paragraph>
                Start by adding your first comment
              </Typography>
              <Button
                variant="contained"
                startIcon={<AddCommentIcon />}
                onClick={() => setTabValue(0)}
              >
                Add Comment
              </Button>
            </Box>
          )}
        </Box>
      </TabPanel>
    </StyledDialog>
  );
};
